<template>
  <div>
    <md-dialog
      v-model="accountVisible"
      :closable="false"
      :btns="btns"
    >
      {{ message }}
    </md-dialog>
  </div>
</template>

<script>
import { Dialog } from 'mand-mobile'
import { mapMutations } from 'vuex'
export default {
  name: 'AccountError',
  components: {
    [Dialog.name]: Dialog
  },
  data () {
    return {
      btns: [
        {
          text: this.$t('i_know'),
          handler: this.onBasicConfirm
        }
      ],
      message: ''
    }
  },
  computed: {
    accountVisible: {
      get () {
        return this.$store.state.accountVisible
      },
      set () {}
    }
  },
  updated () {
    if (!this.message) {
      // HACK 判断为完成
      const { accountStatus } = this.$store.getters
      // 账户状态异常
      if (accountStatus) {
        this.message = this.$t('customer_phone') // 账户状态异常
      }
    }
  },
  methods: {
    ...mapMutations(['change_accountVisible']),
    onBasicConfirm () { // 确认按钮
      this.change_accountVisible(false)
    }
  }
}
</script>me

<style lang="scss" scoped>
::v-deep .md-dialog-body {
  text-align: center;
  line-height: 48px;
}

::v-deep .md-dialog-content {
  border-radius: 32px;
}
</style>
